<template>
  <div class="service-wrap pt-20 pb-20">
    <div class="container">
      <!-- En-tête -->
      <div class="row mb-5">
        <div class="col-12 text-center">
          <!-- <h2 class="section-title">Tutorat</h2> -->
          <p class="section-subtitle">
            Le tutorat est un programme pour la valorisation des Disciples d’Emmaüs ayant fini le parcours des 3 ans à travers le partage d’expériences et la transmission aux nouveaux. Il fait participer les anciens à la formation des nouveaux. Il aide à l’atteinte des objectifs de l’école et favorise un meilleur suivi des apprenants.
          </p>
        </div>
      </div>

      <!-- Deux colonnes : 4/12 et 8/12 -->
      <div class="row g-4 d-flex align-items-start">

        <!-- Qui peut être tuteur ? -->
        <div class="col-12 col-lg-5 d-flex">
          <div class="tutor-card flex-fill">
            <h3 class="tutor-section-title">Qui peut être tuteur ?</h3>
            <ul class="tutor-list">
              <li>Celui ou celle qui a fini la 3ème année, qui a milité dans un groupe, mouvement, laboratoire (avis du responsable requis), et fait la demande. Il a des dispositions de communication et de travail en équipe.</li>
              <li>Le nouveau tuteur suit une formation (au moins 3 séances de 3h) sur l’EITP, sa vision, ses activités, et les techniques de communication.</li>
              <li>Après la formation, les tuteurs sont présentés lors d’une cérémonie officielle.</li>
              <li>Chaque année, une journée de formation conviviale est proposée par l’école aux tuteurs. La participation est nécessaire.</li>
              <li>Le tuteur reçoit un badge avec son nom et le logo de l’école, qu’il porte lors des activités.</li>
            </ul>
          </div>
        </div>

        <!-- Que fait-il ? -->
        <div class="col-12 col-lg-7 d-flex">
          <div class="tutor-card flex-fill">
            <h3 class="tutor-section-title">Que fait-il ?</h3>

            <h4 class="tutor-subtitle">Inscriptions</h4>
            <ul class="tutor-list">
              <li>Participe aux campagnes d’inscriptions et fait les exhortations à l’Église.</li>
              <li>Supervise ou anime les entretiens des nouveaux et fait un point pour un meilleur suivi.</li>
            </ul>

            <h4 class="tutor-subtitle">Cours</h4>
            <ul class="tutor-list">
              <li>Accompagne les nouveaux en 3 séances à l’École, échange sur l’esprit de la formation, leur parcours et les difficultés rencontrées.</li>
              <li>Les informations obtenues durant ces séances restent confidentielles.</li>
              <li>Peut participer au dépouillement de l’évaluation des professeurs à la fin d’un cours.</li>
            </ul>

            <h4 class="tutor-subtitle">Examen de fin d’initiation</h4>
            <ul class="tutor-list">
              <li>Assiste les professeurs pour l’évaluation orale et participe à la délibération des disciples.</li>
            </ul>

            <h4 class="tutor-subtitle">Cérémonie académique et de fin d’initiation</h4>
            <ul class="tutor-list">
              <li>Transmet les attestations de fin de formation.</li>
              <li>Remet les écharpes.</li>
            </ul>

          </div>
        </div>

      </div>
      <div class="row g-4 mt-3">
            <div
              class="col-xl-3 col-lg-3 col-md-4 col-sm-6"
              v-for="etu in etudiants"
              :key="etu.id"
            >
              <div class="prof-mini-card">
                <img
                  v-if="etu.user?.urlImage"
                  :src="getImageUrl(etu.user.urlImage)"
                  alt="Photo disciple"
                  class="prof-photo"
                />

                <img
                  v-else
                  :src="defaultPhoto"
                  alt="Photo par défaut"
                  class="prof-photo"
                />
                <h5 class="prof-mini-name">
                  <router-link
                    :to="`/disciplesEmmaius/${etu.id}`"
                    class="prof-link"
                  >
                    {{ etu.nom }} {{ etu.prenom }}
                  </router-link>
                </h5>
              </div>
            </div>
    </div>
    <div class="mt-4">
          <PaginationComponent
            :page="page"
            :totalPages="totalPages"
            :totalElements="totalElements"
            :limit="limit"
            @paginate="handlePaginate"
          />
    </div>
    </div>
    
  </div>
</template>


<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import ApiService from "@/services/ApiService";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import debounce from "lodash/debounce";

interface Etudiant {
  id: number;
  nom: string;
  prenom: string;
  photo: string;
  autreQualification:string
  user?:User
}
interface User {
  urlImage?: string
}


export default defineComponent({
  name: "LesDisciplesEmmaus",
  components: { PaginationComponent },

  setup() {
    const etudiants = ref<Etudiant[]>([]);
    const defaultPhoto = "/22.png";

    const page = ref(1);
    const limit = ref(12);
    const totalPages = ref(0);
    const totalElements = ref(0);
    const searchTerm = ref('');
   

    // Pagination handler
    const handlePaginate = ({ page_: newPage, limit_: newLimit }) => {
      page.value = newPage;
      limit.value = newLimit;
      getTreeDisciples(newPage, newLimit);
    };
    function rechercher(){
      getTreeDisciples(page.value, limit.value, searchTerm.value );
    }
    // Chargement des étudiants
    const getTreeDisciples = async (pageNum = 1, limi = 12, searchTerm='') => {
      try {
        const { data } = await ApiService.get(
          `/formateurs/Tutorat?page=${pageNum}&limit=${limi}&mot=${searchTerm}&`
        );
        etudiants.value = data.data.data;
        console.log("gggg",etudiants.value)
        totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;

      } catch (error) {
        console.error("Erreur chargement disciples :", error);
      }
    };
    function getImageUrl(filename?: string) : string {
      if (!filename) return ''
      return `${ApiService.vueInstance.axios.defaults.baseURL?.split("api")[0]}uploads/Users/${filename}`; }

    // Chargement initial
    onMounted(() => {
      getTreeDisciples(page.value, limit.value);
    });

    return {
      etudiants,
      defaultPhoto,
      page,
      limit,
      totalPages,
      totalElements,
      handlePaginate,
      rechercher,
      searchTerm,
      getImageUrl
    };
  },
});
</script>


<style scoped>
.service-wrap {
  background-color: #f8f9fa;
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.section-subtitle {
  font-size: 1.1rem;
  color: #6c757d;
  margin-bottom: 2rem;
  max-width: 1000px; /* Limite la largeur du texte */
  margin-left: auto;
  margin-right: auto; /* Centre le texte */
  line-height: 1.6; /* Améliore la lisibilité */
  text-align: center; /* Centre le texte sur la ligne */
}


.section-subtitle {
  font-size: 1.1rem;
  color: #6c757d;
  margin-bottom: 2rem;
}

.tutor-card {
  background: white;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.08);
  transition: all 0.3s ease;
}

.tutor-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
}

.tutor-section-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #0b1b3f;
  margin-bottom: 15px;
}

.tutor-subtitle {
  font-size: 1.2rem;
  font-weight: 600;
  color: #0b1b3f;
  margin-top: 20px;
  margin-bottom: 10px;
}

.tutor-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}

.tutor-list li {
  position: relative;
  padding-left: 20px;
  margin-bottom: 10px;
  font-size: 0.95rem;
  color: #6c757d;
}

.tutor-list li::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #ffc107; /* petit accent jaune */
}

.section-text {
    font-size: 20px
  }
  .prof-mini-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 6px 18px rgba(0,0,0,0.1);
  transition: 0.3s;
}

.prof-mini-card:hover {
  transform: translateY(-6px);
}

.prof-photo {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #ffc107;
  margin-bottom: 10px;
}

.prof-mini-name {
  font-weight: 800;
  color: #0b1b3f;
  cursor: pointer;
}

.prof-mini-name:hover {
  color: #ffc107;

  .year-simple {
  margin-bottom: 20px;
}

.year-title {
  font-weight: 800;
  color: #0b1b3f;
}

.matiere-list {
  padding-left: 18px;
}

.matiere-list li {
  list-style: disc;
  padding: 3px 0;
}
.prof-link {
  text-decoration: none;
  color: inherit;
}

.prof-link:hover {
  color: #ffc107;
}

}

.search-wrapper {
  display: flex;
  justify-content: flex-start;
}

.search-box {
  position: relative;
  width: 100%;
  max-width: 380px;
}

.search-box input {
  width: 200%;
  height: 48px;
  padding: 0 50px 0 18px;
  border-radius: 15px;
  border: 2px solid #e6e6e6;
  font-size: 20px;
  color: #0b1b3f;
  transition: all 0.3s ease;
  background-color: #fff;
}

.search-box input::placeholder {
  color: #999;
  font-size: 20px;
}

.search-box input:focus {
  outline: none;
  border-color: #ffc107;
  box-shadow: 0 0 0 4px rgba(255, 193, 7, 0.15);
}

.search-box button {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #ffc107;
  font-size: 18px;
  cursor: pointer;
  transition: transform 0.2s ease, color 0.2s ease;
}

.search-box button:hover {
  color: #0b1b3f;
  transform: translateY(-50%) scale(1.1);
}

/* Responsive */
@media (max-width: 576px) {
  .search-wrapper {
    justify-content: center;
  }

  .search-box {
    max-width: 100%;
  }
}

</style>
